import { useQuery } from '@tanstack/react-query'
import { storeService } from '../services/storeService'

const useStoreConfig = () => {
    return useQuery({ queryKey: ['storeconfig'], queryFn: () => storeService.getStore(), retry: false })
}

export default useStoreConfig
